<template>
  <component :is="selectedComponent" :country="country" />
</template>

<script>
import DiscoverLoggedOut from "@/views/sales/DiscoverView.vue";
import { mapState } from "pinia";
import { UserStore } from "@/stores/userStore";
import DiscoverLoggedApp from "@/views/app/DiscoverLoggedApp.vue";

export default {
  name: "DiscoverGeneric",
  components: {
    DiscoverLoggedOut,
  },
  props: {
    country: {
      type: String,
      required: false,
    }
  },
  computed: {
    ...mapState(UserStore, ["isLoggedIn"]),
    selectedComponent() {
      return this.isLoggedIn ? DiscoverLoggedApp : DiscoverLoggedOut;
    },
  },
};
</script>

<style scoped lang="scss"></style>
